import { gql } from '@apollo/client'

import { ZoneFragment } from '../fragments'

export const MUTATION_CREATE_ZONE = gql`
  mutation createZone($input: ZoneCreateInput!) {
    createZone(input: $input) {
      ...ZoneFragment
    }
  }
  ${ZoneFragment}
`

export const MUTATION_UPDATE_ZONE = gql`
  mutation updateZone($input: ZoneUpdateInput!) {
    updateZone(input: $input) {
      ...ZoneFragment
    }
  }
  ${ZoneFragment}
`

export const MUTATION_DUPLICATE_ZONE = gql`
  mutation duplicateZone($input: ZoneDuplicateInput!) {
    duplicateZone(input: $input) {
      ...ZoneFragment
    }
  }
  ${ZoneFragment}
`

export const MUTATION_DELETE_ZONE = gql`
  mutation deleteZone($id: ID!) {
    deleteZone(id: $id)
  }
`

export const MUTATION_SORT_ZONES = gql`
  mutation sortZones($input: ZonesSortInput!) {
    sortZones(input: $input) {
      ...ZoneFragment
    }
  }
  ${ZoneFragment}
`
